<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label>Тип операции</label>
    <el-select
      placeholder="Выберите тип операции"
      v-model="localValue"
      :disabled="disabled"
      >
      <el-option value="D" label="+ Пополнение"></el-option>
      <el-option value="C" label="- Снятие"></el-option>
    </el-select>
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'transaction-type-field',
  props: {
    value: [String, Number],
    error: Array,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue: ''
    }
  },
  mounted () {
    this.localValue = this.value
  },
  watch: {
    value: function (val) {
      this.localValue = val
    },
    localValue: function (val) {
      this.updateValue(val)
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// TransactionType.vue?129b8af4